import React from 'react';
import './Collab.css';
import { useLanguage } from './LanguageContext';
import translations from './translations';

function Collab() {
  const { language } = useLanguage();
  const t = translations[language];
  return (
    <div className="Collab-section">
      <h1 className="Collab-title">
  {t.collabTitle[0]} <br /> {t.collabTitle[1]}
</h1>
      <div className="Collab-img-wrap">
        <img src="/collab.png" alt="Collaboration Events" />
      </div>
    </div>
  );
}

export default Collab;